import React from "react"
import { Box, BoxProps, Fade, Text } from "@chakra-ui/react"

type FullTextProps = {
  in: boolean
  text?: string
  fadeStyle?: React.CSSProperties
  boxProps?: BoxProps
}
const FullText = ({ text = "", ...props }: FullTextProps) => {
  return (
    <Fade
      in={props.in}
      transition={{ exit: { delay: 0.4 }, enter: { duration: 0.4 } }}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        ...props.fadeStyle,
      }}>
      <Box
        w="100%"
        h="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p="0"
        {...props.boxProps}>
        <Text fontSize="sm" color="gray.500">
          {text || "查無資料"}
        </Text>
      </Box>
    </Fade>
  )
}

export default FullText
